export const STATUS = {
  PROCESSED: 'processed',
  NOT_PROCESSED: 'not_processed',
  COMPLETED: 'completed',
  IN_PROGRESS: 'in_progress',
} as const;

type StatusType = (typeof STATUS)[keyof typeof STATUS];

type Props = {
  status: StatusType;
  className?: string;
};

const STATUSES: Record<StatusType, { background: string; text: string; label: string }> = {
  [STATUS.PROCESSED]: {
    background: 'bg-green-200/10',
    text: 'text-green-200',
    label: 'Обработан',
  },
  [STATUS.NOT_PROCESSED]: {
    background: 'bg-red-200/10',
    text: 'text-red-200',
    label: 'Не обработан',
  },
  [STATUS.COMPLETED]: {
    background: 'bg-green-200/10',
    text: 'text-green-200',
    label: 'Выполнен',
  },
  [STATUS.IN_PROGRESS]: {
    background: 'bg-blue-300/10',
    text: 'text-blue-300',
    label: 'В процессе',
  },
};

const StatusBadge = ({ status, className }: Props) => {
  const badge = STATUSES[status];

  return (
    <div className={`rounded-full py-1 px-3 inline-block ${badge.background} ${className}`}>
      <span className={`text-xs font-normal whitespace-nowrap ${badge.text}`}>{badge.label}</span>
    </div>
  );
};

export default StatusBadge;
